import moment from "moment";
import modelBaseV2 from "../../model-base-v2.model";

/**
 * Sales Report Model
 * 
 * @author cmc.nttruong1
 */

const SalesReportModel = {
  getListSites: () => {
    return modelBaseV2.get('/api/site/managed');
  },
  searchSalesReport: (body) => {
    return modelBaseV2.post('/api/report/sales', { body });
  },
  downloadExcel: (body) => {
    const fileName = `Sales_Report_${moment().format('YYYYMMDDhhmm')}`;
    return modelBaseV2.postDownload('/api/report/sales/export', { body }, fileName);
  }
}
export default SalesReportModel;